define('gameday-device-interaction/type',['require','exports','module'],function(require,exports,module){
    var type;
    return function(typeOverride){
        type = typeOverride || type || module.config();
        return typeof type === 'string' ? type : 'default';
    }
});
